module.exports = "/_next/static/images/Processing@2x-09b1ae378a1b04e0e9e6b3ae300f0d88.png";